export type Integration = {
  integration_id: number;
  name: string;
  settings: string;
  options: string;
  created_by: IntegrationCreatedBy;
};

export type IntegrationCreatedBy = {
  user_id: number;
  email: string;
  full_name: string;
};

export enum IntegrationScope {
  TENANT = "tenant",
  CASE = "case",
  USER = "user",
}

export type IntegrationContext = {
  scope: IntegrationScope;
  case_uuid?: string;
};

export type IntegrationUser = {
  full_name: string;
  title?: string;
  organization?: string;
  email: string;
  phone?: string;
  mobile?: string;
  id: string;
  type?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  notes?: string;
};
